import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function NavigateToLogin() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/login', search }} replace />;
}
